module.exports = __webpack_public_path__ + "img/process_img1.cbd50ee3.png";